module.exports = __webpack_public_path__ + "static/media/amo3.c93217c6.webp";